import React from "react";
import { useState } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addNewCountry } from "../../Redux/Actions/settingsActions";
import TextInput from "../../Global Functions/textInput";
import SelectInput from "../../Global Functions/selectInput";
import toast from "react-hot-toast";
import './addCountry.css'

const AddCountry = () => {
  const [countryData, setCountryData] = useState({
    country_name: "",
    country_code: "",
    country_language_code: "",
    country_language_name: "",
    country_currency_symbol: "",
    country_phone_code: "",
    country_currency: "",
    country_flag: "",
    country_having: "",
  });

  const CountryHaving = {
    STATE: "states",
    CITY: "cities",
    REGION: "regions",
    PROVINCE: "province",
  };

  const dropdownOptions = ["REGION", "STATE", "PROVINCE", "CITY"];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { admin } = useSelector((state) => state.admin);

  console.log("DATA", admin.data.access_code)

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!countryData.country_name?.trim()) {
      toast.error("Country Name is required");
      return;
    }

    if (!countryData.country_code?.trim()) {
      toast.error("Country ISO Code is required");
      return;
    }

    if (!countryData.country_language_name?.trim()) {
      toast.error("National Language is required");
      return;
    }

    if (!countryData.country_language_code?.trim()) {
      toast.error("Language Code is required");
      return;
    }

    if (!countryData.country_currency?.trim()) {
      toast.error("Country Currency is required");
      return;
    }

    if (!countryData.country_currency_symbol?.trim()) {
      toast.error("Currency Symbol is required");
      return;
    }

    if (!countryData.country_phone_code?.toString().trim()) {
      toast.error("Country Phone Code is required");
      return;
    }

    if (!countryData.country_having?.trim()) {
      toast.error("Administrative Division is required");
      return;
    }
    try {
      const response = await dispatch(addNewCountry(countryData));
      if (response.statusCode === 200) {
        navigate(-1);
      }
      setCountryData({
        country_name: "",
        country_code: "",
        country_language_code: "",
        country_language_name: "",
        country_currency_symbol: "",
        country_phone_code: "",
        country_currency: "",
        country_flag: "",
        country_having: "",
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setCountryData((prevData) => {
      let updatedData = { ...prevData, [name]: value };

      if (name === "country_code") {
        updatedData.country_flag = value.substring(0, 2).toLowerCase() + ".svg";
      }
      if (name === "country_having") {
        updatedData.country_having = value;  
      }
      return updatedData;
    });
  };

  return (
    <MainLayout>
      <div className="padding-20 bg-white border-24 grid-span-5" style={{ width: '100%' }}>
        <div className="flex-container flex-justify-between">
          <h1>Add Country</h1>
          <Link to="/country">
            <button className="button-class">View Country List</button>
          </Link>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label={<span>
                  Country Name<span style={{ color: "red" }}>*</span>
                </span>}
                value={countryData.country_name}
                name="country_name"
                type="text"
                placeholder="Enter Name"
                onChange={handleAddChange}
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                onChange={handleAddChange}
                name="country_code"
                label={<span>Country ISO Code<span style={{ color: "red" }}>*</span>
                </span>}
                placeholder="Enter Code"
                type="text"
                value={countryData.country_code}
              ></TextInput>
            </div>
          </div>
          <div className="margin-h-10 flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label={<span>National Language<span style={{ color: "red" }}>*</span>
                </span>}
                value={countryData.country_language_name}
                onChange={handleAddChange}
                name="country_language_name"
                placeholder="Enter Title"
                type="text"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                label={<span>Language Code<span style={{ color: "red" }}>*</span>
                </span>}
                value={countryData.country_language_code}
                onChange={handleAddChange}
                name="country_language_code"
                placeholder="Enter Language Code"
                type="text"
              ></TextInput>
            </div>
          </div>
          <div className="margin-h-10 flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label={<span>Country Currency<span style={{ color: "red" }}>*</span>
                </span>}
                value={countryData.country_currency}
                onChange={handleAddChange}
                name="country_currency"
                placeholder="Enter Currency"
                type="text"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <TextInput
                label={<span>Currency Symbol<span style={{ color: "red" }}>*</span>
                </span>}
                value={countryData.country_currency_symbol}
                onChange={handleAddChange}
                name="country_currency_symbol"
                placeholder="Currency Symbol"
                type="text"
              ></TextInput>
            </div>
          </div>
          <div className="margin-h-10 flex-container flex-justify-between gap-10">
            <div style={{ width: "50%" }}>
              <TextInput
                label={<span>Country Phone Code<span style={{ color: "red" }}>*</span>
                </span>}
                value={countryData.country_phone_code}
                onChange={handleAddChange}
                name="country_phone_code"
                placeholder="Enter Phone Code"
                type="number"
              ></TextInput>
            </div>
            <div style={{ width: "50%" }}>
              <SelectInput
                label={<span>Select Administrative Division<span style={{ color: "red" }}>*</span>
                </span>}
                name="country_having"
                value={countryData.country_having}
                placeholder="Select An Option"
                onChange={handleAddChange}
                options={
                  Array.isArray(dropdownOptions)
                    ? dropdownOptions.map((option) => ({
                      label: option,
                      value: option,
                    }))
                    : []
                }
              ></SelectInput>
            </div>
          </div>
          <div className="flex-end margin-h-10">
            <Link to="/country">
              <button type="button" className="button-class-white">Cancel</button>
            </Link>
            <button type="submit" className="button-class">Save</button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddCountry;
